import { createSelector } from '@reduxjs/toolkit';
import { signalRAdapter } from '@s20/slices/features/signalr.slice';
import { selectItemById } from '@s20/selectors/common';
import { RootState } from '../../store';

const {
    selectEntities,
} = signalRAdapter.getSelectors<RootState>((state) => state.signalR);

export const getHubByUrl = createSelector(
    selectEntities,
    selectItemById,
    (hubs, hubUrl) => hubs[hubUrl],
);